import SideBar from '../../../components/SideBar';
import { connect } from 'react-redux';
import { Outlet,useParams } from 'react-router-dom';

const Body = (props) => {
  const {deviceId} = useParams()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        minWidth: 0,
        width: '100%',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <SideBar 
        deviceId = {deviceId}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.tk !== null,
    token: state.auth.tk,
    userDetails: state.auth.userDetails,
    authChecked: state.auth.authChecked,
  };
};

export default connect(mapStateToProps)(Body);
